import { useState } from 'react';

const useCopyToClipboard = () => {
    const [copySuccess, setCopySuccess] = useState<boolean>(false);
    const [copyFailure, setCopyFailure] = useState<boolean>(false);

    const copyToClipboard = async (text: string) => {
        try {
            // Navigator API only works for secure context
            if (navigator.clipboard && window.isSecureContext) {
                console.log(`Copying "${text}" to clipboard using navigator API`);
                return await navigator.clipboard.writeText(text).then(() => setCopySuccess(true));
            } else {
                // Fallback option: create DOM element and execCommand
                console.log(`Copying "${text}" to clipboard using DOM element`);
                let textArea = document.createElement('textarea');
                textArea.value = text;
                textArea.style.position = 'fixed';
                textArea.style.left = '-999999px';
                textArea.style.top = '-999999px';
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                document.execCommand('copy');
                textArea.remove();
            }
        } catch (e) {
            console.log(e);
            setCopyFailure(true);
        }
    };

    return { copyToClipboard, copySuccess, copyFailure };
};

export default useCopyToClipboard;
